export default __webpack_public_path__ + "static/media/pessoa.aded29fb.png";